import JobItem from "../components/JobItem"
import Filter from "../components/Filter"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchJobs } from './../redux/features/Job/jobSlice';


export default function Homepage() {
    const dispatch= useDispatch();
    const {jobs, isLoading, isError} = useSelector(state=>state.jobs) || {};
    const {filter, search, sort} = useSelector(state=>state.filters) || {};

    useEffect(()=>{
        dispatch(fetchJobs());
    },[dispatch])
    
    // filter callback functions
    const FilterCallback = (item)=> filter?.length > 0  ? item.type === filter : true
    const searchCallback = (item)=> {
        if(search?.length > 0){
            return item.title.toLowerCase().includes(search.toLowerCase())
        } else {return true}
    }

    const sortCallback = (a,b)=> {
        if(sort?.length > 0 && sort === "ace"){
            return Number(a.salary) - Number(b.salary)
        } else if(sort?.length > 0 && sort === "desc") {
            return Number(b.salary) - Number(a.salary)
        }else {return true}
    }

    // decide render content
    let content = null;
    if(isLoading) content = <div>Loading....</div>
    if(!isLoading && isError) content = <div>There was an error ocurred</div>
    if(!isLoading && !isError && jobs.length === 0) content = <div>No Job Found</div>
    if(!isLoading && !isError && jobs.length > 0) {
        content = (jobs
            .filter(FilterCallback)
            .filter(searchCallback)
            .sort(sortCallback)
            .map(job=>{
            return (<JobItem key={job.id} job={job}/>)
        }))
    }
    return (
        <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
            <Filter/>
            <div className="jobs-list">
                {content}
            </div>
        </main>
    )
};